/** @format */

import {OauthProvider} from 'graphql/generated/types';

export const AD_PROVIDERS: OauthProvider[] = ['YANDEX', 'VKONTAKTE', 'VKONTAKTE_ADS', 'GOOGLE'];
